import { jsx as _jsx } from "react/jsx-runtime";
import GenericSettingsPage from './GenericSettingsPage';
const ProductionLinesPage = () => {
    const columns = [
        { key: 'name', label: 'Name', type: 'text', required: true },
        { key: 'description', label: 'Description', type: 'text' },
        { key: 'capacity_per_day', label: 'Daily Capacity', type: 'number', min: 0 },
        { key: 'sort_order', label: 'Sort Order', type: 'number', min: 0 },
    ];
    return (_jsx(GenericSettingsPage, { tableName: "production_lines", title: "Production Lines", columns: columns, apiPath: "production_lines" }));
};
export default ProductionLinesPage;
